export const HELP_CENTER_LINK = 'https://help.mentortools.com'

export const getLocalizedHelpCenterLink = (locale: string) => {
  if (locale === 'de') return `${HELP_CENTER_LINK}/de/`

  if (locale === 'sk' || locale === 'cz') return `${HELP_CENTER_LINK}/sk/`

  return `${HELP_CENTER_LINK}/en/`
}
